module.exports = __webpack_public_path__ + "img/Ident-Process-6-mobile.42a82095.png";